import { footerLinks } from "@/mocks/navData";

export default function Footer() {
  return (
    <footer className="bg-[#2e2417] text-[#eadfcc]">
      <div className="mx-auto w-full max-w-[1240px] px-4 pt-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 pb-10 md:grid-cols-[minmax(0,1.4fr)_minmax(0,1fr)]">
          <div className="max-w-md">
            <a href="#top" className="inline-flex cursor-pointer items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#e4562b] text-lg font-bold text-white">
                瓜
              </span>
              <span className="leading-none">
                <span className="block text-xl font-bold tracking-tight text-white">吃瓜地址</span>
                <span className="mt-1 block text-[10px] font-semibold uppercase tracking-[0.28em] text-[#d9b57e]">
                  Chigua · Direct
                </span>
              </span>
            </a>
            <p className="mt-5 text-sm leading-relaxed text-[#b7a888]">
              一张把热门地址收拢的直达地图：一键直达、快速导航、跳转短链。
              不用反复搜索，点开即用，随时找瓜看料都省心。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              <a
                href="#top"
                className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-[#e4562b] px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#c8421c]"
              >
                <i className="ri-arrow-right-line text-base"></i>
                回到首屏
              </a>
              <a
                href="#faq"
                className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-[#5a4932] px-4 py-2 text-sm text-[#d8cbb6] transition-colors hover:border-[#e4562b] hover:text-white"
              >
                常见问题
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            {footerLinks.map((col) => (
              <div key={col.group}>
                <h4 className="text-sm font-semibold text-white">{col.group}</h4>
                <ul className="mt-4 space-y-3">
                  {col.items.map((item) => (
                    <li key={item}>
                      <a
                        href="#top"
                        className="cursor-pointer text-sm text-[#b7a888] transition-colors hover:text-[#e4562b]"
                      >
                        {item}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col items-start justify-between gap-3 border-t border-[#4a3c28] py-6 sm:flex-row sm:items-center">
          <p className="text-xs text-[#9a8a70]">
            © 2026 吃瓜地址 · 汇集热门直达入口，仅供信息导航与跳转之需。
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#top" className="cursor-pointer text-xs text-[#9a8a70] hover:text-white">
              直达 · 导航 · 短链
            </a>
            <a href="#faq" className="cursor-pointer text-xs text-[#9a8a70] hover:text-white">
              收录原则
            </a>
            <a href="#guide" className="cursor-pointer text-xs text-[#9a8a70] hover:text-white">
              使用帮助
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}